import { render, staticRenderFns } from "./FlowFormRightSubSetting.vue?vue&type=template&id=2f354426&scoped=true&"
import script from "./FlowFormRightSubSetting.vue?vue&type=script&lang=js&"
export * from "./FlowFormRightSubSetting.vue?vue&type=script&lang=js&"
import style0 from "./FlowFormRightSubSetting.vue?vue&type=style&index=0&id=2f354426&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f354426",
  null
  
)

export default component.exports